module.exports = __webpack_public_path__ + "static/media/heart.d7d56949.svg";